import { Component, OnInit } from "@angular/core";
import { HttpService } from "src/app/http.service";
import { GlobalService } from "../../global.service";

@Component({
  selector: "app-input-stock-entry",
  templateUrl: "./input-stock-entry.component.html",
  styleUrls: ["./input-stock-entry.component.scss"],
})
export class InputStockEntryComponent implements OnInit {
  by_product_group_list = [];
  by_product_dict = {};
  title = "";

  constructor(private HttpService: HttpService, private global: GlobalService) {
    this.title = this.global._active_display_name;
    this.serveByProductStock();
    
  }

  serveByProductStock() {
    this.HttpService.serveInputStock().subscribe(
      (data) => {
        console.log(data);
        this.by_product_group_list = data["by_product_group_list"];
        this.by_product_dict = data["by_product_dict"];
      },
      (error) => {
        console.error(error);
      }
    );
  }

  updateCalled(product_id, new_qty, bill_number, expiry_date) {
    console.log(product_id);
    console.log(new_qty);
    let data_dict = {
      'product_id': product_id,
      'quantity': new_qty,
      'bill_number': bill_number,
      'expiry_date': expiry_date
    }
    console.log(data_dict);
    this.HttpService.createInputStockRecord(data_dict).subscribe((data) => {
      console.log(data);
      this.serveByProductStock();
    }, (error) => {
      console.error(error);
    });
  }
  
  addNewAndOldQty(product_group_id, product_index) {
    let old_qty = this.by_product_dict[product_group_id][product_index]['quantity_now'];
    let new_qty = this.by_product_dict[product_group_id][product_index]['new_quantity'];
    if (new_qty == null) {
      new_qty = 0;
    }
    return old_qty + new_qty
  }
  
  checkValidForUpdate(product_group_id, product_index) {
    if (this.by_product_dict[product_group_id][product_index]['new_quantity'] <= 0 || this.by_product_dict[product_group_id][product_index]['new_quantity'] == null || this.by_product_dict[product_group_id][product_index]['expiry_date'] == null) {
      return true;
    } else {
      return false;
    }
  }

  changeToAddProduct(product_group_id, product_index) {
    this.by_product_dict[product_group_id][product_index]['is_editable'] = !this.by_product_dict[product_group_id][product_index]['is_editable']
    this.by_product_dict[product_group_id][product_index]['new_quantity'] = null
    this.by_product_dict[product_group_id][product_index]['expiry_date'] = null
    this.by_product_dict[product_group_id][product_index]['bill_number'] = null
  }

  ngOnInit() {}
}
